import React, { Component } from 'react';
import { message } from 'antd';
import { Link } from 'react-router-dom';
import dclogo from "../../../../Assets/images/doodycalls.png";
import RightSlider from '../../Common/RightSlider';
import {errorHandle} from "../../../Common/errorHandle";

class ForgotPassword extends Component {

  state = { loader: false, email: '', is_btn_active: false, forgot_success: false }


  componentDidMount = () => {
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";
    if (accessToken) {
      this.props.history.push('/dashboard')
    }
  }



  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    // Register User Response
    if (Object.keys(props.ForgotPwd.data).length > 0 && props.ForgotPwd.data !== this.props.ForgotPwd.data) {
      // display Success messsage
      this.setState({ forgot_success: true })
    }
    if (Object.keys(props.ForgotPwd.errors).length > 0 && props.ForgotPwd.errors !== this.props.ForgotPwd.errors) {
      // display error messsage
      this.setState({ forgot_success: false })
      if (props.ForgotPwd.errors.email) {
        message.error(props.ForgotPwd.errors.email, 10);
      }
      else {
        errorHandle(props.ForgotPwd.errors)
      }


    }
    this.setState({ loader: false })
  }

  // set email value
  onUserChange = (e) => {
    const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({ [e.target.name]: e.target.value })

    if (e.target.value.toString().toLowerCase().match(REGULAR_EXPRESSION_EMAIL)) {
      this.setState({
        is_btn_disbale: true
      })
    }
    else {
      this.setState({
        is_btn_disbale: false
      })
    }
  }

  // Call forgot Password API
  forgotPassword = (e) => {
    let { email } = this.state;
    e.preventDefault();
    this.setState({ loader: true })
    this.props.forGotPWD({ email, is_crm: true });
  }
  render() {
    let { loader, email, is_btn_disbale, forgot_success } = this.state;
    return (
      <div id="wrapper">
        <div className="auth-page">
          <div className="authform">
            <div className="auth-container">
              <img src={dclogo} alt="" className="logo" />

              {!forgot_success ?
                <React.Fragment>
                  <h1>Forgot password?</h1>
                  <h5 className="mb-30">No problem! Sit, Stay, Enter your email address.<br />Password reset instructions will be sent to your email.</h5>
                  <form className="form-group" onSubmit={(e) => { this.forgotPassword(e) }}>
                    <div className="fitem">
                      <label>Email Address</label>
                      <input
                        type="text"
                        value={email}
                        name="email"
                        onChange={(e) => { this.onUserChange(e) }}
                        placeholder="Email Address" />
                    </div>
                    <div className="btn-grp flex ai-center">
                      <Link to="/" replace className="m-0">‹ Back to Login</Link>

                      <button
                        type="submit"
                        disabled={!is_btn_disbale}
                        className={!is_btn_disbale ? 'btn btn-primary disable' : 'btn btn-primary'} >Recover</button>
                    </div>
                  </form>
                </React.Fragment> :

                <React.Fragment>
                  <h1>Password recovery email sent.</h1>
                  <label className="mb-30">Please check your emails to proceed.</label>
                  <div className="btn-grp text-right">
                    <Link to="/" replace >
                      <button
                        type="submit"
                        className="btn btn-primary"
                      >Back to Login</button>
                    </Link>


                  </div>
                </React.Fragment>}


            </div>
          </div>
          <RightSlider />
        </div>
        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div>
    );
  }
}

export default ForgotPassword;